var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.47.47a.75.75 0 0 1 1.06 0L5 3.94 8.47.47a.75.75 0 0 1 1.06 1.06L5 6.06.47 1.53a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC40Njk2NyAwLjQ2OTY3QzAuNzYyNTYzIDAuMTc2Nzc3IDEuMjM3NDQgMC4xNzY3NzcgMS41MzAzMyAwLjQ2OTY3TDUgMy45MzkzNEw4LjQ2OTY3IDAuNDY5NjdDOC43NjI1NiAwLjE3Njc3NyA5LjIzNzQ0IDAuMTc2Nzc3IDkuNTMwMzMgMC40Njk2N0M5LjgyMzIyIDAuNzYyNTYzIDkuODIzMjIgMS4yMzc0NCA5LjUzMDMzIDEuNTMwMzNMNSA2LjA2MDY2TDAuNDY5NjcgMS41MzAzM0MwLjE3Njc3NyAxLjIzNzQ0IDAuMTc2Nzc3IDAuNzYyNTYzIDAuNDY5NjcgMC40Njk2N1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";